export default "__VITE_ASSET__DfSo6qCC__"